import _objectWithoutProperties from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/WEC-SIN33-JOB1/packages/web/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["title", "titleId"];
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
function Contract(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15.521 1c1.296 0 2.405.823 2.829 1.974l.544-1.156a1 1 0 011.332-.48l2.312 1.09a1 1 0 01.479 1.33l-4.483 9.512v6.577a3.017 3.017 0 01-3.013 3.013H4.013A3.017 3.017 0 011 19.847V4.012A3.016 3.016 0 014.013 1h11.508zm0 2H4.013C3.454 3 3 3.454 3 4.012v15.835c0 .559.454 1.013 1.013 1.013h11.508c.559 0 1.013-.454 1.013-1.013l-.001-3.813-1.329 1.11a.999.999 0 01-1.64-.767v-3.02c0-.147.033-.293.095-.426l2.874-6.103.001-2.816c0-.558-.454-1.012-1.013-1.012zm-6.37 11.284c.599.435.744 1.21.432 2.3.073-.064.148-.132.228-.205.407-.493 1.353-1.445 2.365-1.105.689.23 1.054.894 1.085 1.971.016.504.352.521.514.53a1.001 1.001 0 01-.051 1.998h-.053c-1.522-.08-2.207-1.15-2.37-2.057-.026.03-.053.058-.082.085-1.274 1.174-2.601 2.258-3.623 1.508-.255-.188-.997-.733-.112-2.877L5.266 18.32a1 1 0 01-1.293-1.525l2.368-2.009c.589-.416 1.884-1.176 2.81-.5zm11.127-10.71l-4.714 10.007v.658l.5-.418L20.78 3.81l-.503-.236zm-7.562 4.502a1 1 0 010 2h-7.09a1 1 0 010-2h7.09zm0-3.538a1 1 0 010 2h-7.09a1 1 0 010-2h7.09z",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}
var MemoContract = React.memo(Contract);
export default MemoContract;